import React, {useEffect, useState} from "react";
import Header from "../components/header/Header";
import Greeting from "./greeting/Greeting";
import ImpactStrip from "./impactStrip/ImpactStrip";
import About from "./about/About";
import WorkExperience from "./workExperience/WorkExperience";
import EngineeringWork from "./github/GitHub";
import Projects from "./projects/Projects";
import Publication from "./publication/Publication";
import Skills from "./skills/Skills";
import Achievement from "./achievement/Achievement";
import Education from "./education/Education";
import Contact from "./contact/Contact";
import Footer from "../components/footer/Footer";
import ScrollToTopButton from "./topbutton/Top";
import SplashScreen from "./splashScreen/SplashScreen";
import {splashScreen} from "../portfolio";
import {StyleProvider} from "../contexts/StyleContext";
import {useLocalStorage} from "../hooks/useLocalStorage";
import "./Main.scss";

const Main = () => {
  const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
  const [isDark, setIsDark] = useLocalStorage("isDark", darkPref.matches);
  const [isShowingSplash, setIsShowingSplash] = useState(true);

  useEffect(() => {
    if (splashScreen.enabled) {
      const t = setTimeout(
        () => setIsShowingSplash(false),
        splashScreen.duration
      );
      return () => clearTimeout(t);
    } else {
      setIsShowingSplash(false);
    }
  }, []);

  const changeTheme = () => setIsDark(v => !v);

  return (
    <div className={isDark ? "dark-mode" : undefined}>
      <StyleProvider value={{isDark, changeTheme}}>
        {isShowingSplash ? (
          <SplashScreen />
        ) : (
          <>
            <Header />
            {/* Section order: Hero → Impact → About → Experience → Engineering Work → Projects → Publication → Capabilities → Certifications → Education → Contact */}
            <Greeting />
            <About />
            <ImpactStrip />
            <WorkExperience />
            <EngineeringWork />
            <Projects />
            <Publication />
            <Skills />
            <Achievement />
            <Education />
            <Contact />
            <Footer />
            <ScrollToTopButton />
          </>
        )}
      </StyleProvider>
    </div>
  );
};

export default Main;
